/*
 * 商品
 *
 * @Author:    1024创新实验室-主任：卓大
 * @Date:      2022-09-03 22:08:10
 * @Wechat:    zhuda1024
 * @Email:     lab1024@163.com
 * @Copyright  1024创新实验室 ( https://1024lab.net )，Since 2012
 */
export const GOODS_STATUS_ENUM = {
  APPOINTMENT: {
    value: 1,
    desc: '预约中',
  },
  SELL: {
    value: 2,
    desc: '售卖中',
  },
  SELL_OUT: {
    value: 3,
    desc: '售罄',
  },
};
export default {
  GOODS_STATUS_ENUM,
};
